import React from "react";

function Contact() {
  return (
    <>
      <section className="contact-us " id="contact">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-5 text-left">
              <div className="title text-left">
                <h3>
                  <b>THANKS!</b>
                </h3>

                <h4>Do you have any questions?</h4>

                <ul className="contact-short-info contact-text">
                  <li>
                    <div>
                      <i className="tf-ion-ios-home"></i>
                      Nexus Glorious, 14/2/3, Old Mahalunge Road,
                      <br />
                      Susgaon,Baner,Pune-411021. Maharashtra,India.
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="tf-ion-android-phone-portrait"></i>
                      Phone: +91 9665433121
                    </div>
                  </li>

                  <li>
                    <div>
                      <i className="tf-ion-android-mail"></i>
                      Email: support@macroziontechsystem.com
                    </div>
                  </li>
                </ul>
                <div className="social-icon">
                  <ul>
                    <li>
                      <a href="/">
                        <i className="tf-ion-social-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        <i className="tf-ion-social-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        <i className="tf-ion-social-dribbble-outline"></i>
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        <i className="tf-ion-social-linkedin-outline"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
